module.exports = __webpack_public_path__ + "static/media/avataaars.b18ac998.svg";